import type { FloorDM, FloorLayout } from '@Model/FloorModels';
import type { FloorsDM } from '@Model/MapModels';
import { injectable } from 'inversify';

import type { GetFloorsResponse } from './ownable.dtos';
import { GetFloors } from './ownable.dtos';
import ServiceStackGateway from './service-stack';

import container from '~ioc/ioc';

@injectable()
export class FloorsListGateway {
  getFloors = async (): Promise<FloorsDM> => {
    const request = new GetFloors();

    const response = await ServiceStackGateway.get<GetFloorsResponse>(request);

    return convertToFloorsDM(response);
  };
}

container.bind(FloorsListGateway).toSelf().inTransientScope();

const convertToFloorsDM = (response: GetFloorsResponse): FloorsDM => {
  const floors = response.floors
    .map((floor) => ({
      id: floor.id,
      title: floor.name,
      floorNumber: floor.floorNumber,
      layout: mapLayout[floor.displayType],
      isDefault: floor.isDefault,
      departments: floor.departments,
      width: floor.width,
      height: floor.height,
    }))
    .sort((a, b) => a.floorNumber - b.floorNumber);

  return { floors, defaultFloor: getDefaultFloor(floors) };
};

const getDefaultFloor = (floors: FloorDM[]): FloorDM['id'] => {
  const defaultFloor = floors.find((floor) => floor.isDefault) ?? floors[0];
  return defaultFloor.id;
};

const mapLayout: Record<string, FloorLayout> = {
  BrandConcession: 'BrandConcession',
  ProductSet: 'ProductSet',
};
